<!-- Header Start -->
<header class="header-hld header-invison">
    <section class="header-bot">
      <div class="container">
        <div class="row">
          <div class="col-9 ">
                    <a href="javascript:void(0)" title="Sanlam" class="logo-hld"
                        [routerLink]="userData!=null?['/portal/home']:['/register']">
                        <app-logo size="large" width="203" height="44" viewBox="0 0 203 44" fill="none"></app-logo>
            </a>
          </div>
          <div class="col-3 text-end d-flex justify-content-end">

          </div>
        </div>
      </div>
    </section>
  </header>

<!-- Header HTML End -->
<section class="register ">
    <div class="container">
        <div class="login-hld">
            <div class="d-flex flex-wrap align-items-stretch">
                <div class="col-lg-6 col-md-7 px-3 regsterfrm col-12">
                    <h2 class="mx-md-0 pt-md-0 caption bottomline mt-0" *ngIf="displaySection==='SendOTPRequest' && !isSecondTimeLogin">
                        <b>Forgot</b> password
                      </h2>
                      <h2 class="mx-md-0 pt-md-0 caption bottomline mt-0" *ngIf="displaySection==='SendOTPRequest' && isSecondTimeLogin">
                        <b>Create</b> Your SCS password
                      </h2>
                    <div *ngIf="displaySection=='UpdatePasswordSection'">
                    <h2 class="mx-md-0 pt-md-0 caption bottomline mt-0"><b>Create </b> password</h2>

                    </div>
                    <!--for Password updated Successfull -->
                    <div *ngIf="displaySection=='OTPSuccessfullyChangedSection'">
                        <h2 class="mx-md-0 pt-md-0 caption bottomline mt-0"><b>Password</b> Updated Successfully</h2>
                        <div class="d-flex w-100 flex-wrap justify-content-between">
                            <div class="col-md-12 btnmbadj px-0 col-12">
                                <button name="Body-Login" (click)="azureAdlogin()" class="btnregister" type="button" id="LoginForgotPasswordPage">Login</button>
                            </div>
                        </div>
                    </div>
                    <!--for Password updated Successfull-->


                    <p class="text-start px-md-0 mt-md-2 mt-0">{{panelText}}</p>
                    <form class="otp-form forgotfm mt-3" [formGroup]="otpForm" (ngSubmit)="forgot()">
                        <div class="d-flex">
                            <div class="modal-body">
                                <div *ngIf="otpErrorMsg!=''" class="alert alert-danger" role="alert" [innerHTML]="otpErrorMsg">

                                </div>
                                <div *ngIf="successMsg!=''" class="alert alert-success" role="alert">
                                    {{successMsg}}
                                </div>
                                <div *ngIf="successMsgWithPipe == true" class="alert alert-success" role="alert">
                                    Your session will expire in {{counter | formatime}}
    
                                </div>

                                <div *ngIf="displaySection=='SendOTPRequest'" class="form-group fullwidth required otpbox-margin">
                                    <div class="form-field mt-3">
                                        <input id="SearchText" type="text" class="form-control" placeholder="" formControlName="SearchText"
                                            maxlength="150" [readonly]="sendOtpText=='Resend OTP'" (keyup)="handleKeyDown($event)">
                                        <label for="SearchText">Cellphone Number or Email Address</label>
                                        <div *ngIf="otpFormControls.SearchText.touched && otpFormControls.SearchText.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="otpFormControls.SearchText.errors.required">Cellphone Number or Email Address is required</div>
                                        </div>                                        
                                    </div>
                                    <br/><label >To <b>update</b> the cellphone number or email. Click on <a href="javascript:void(0)" id="btnCallMeBackForgotPassword"
                                    class="btnblue py-2" (click)="speakToCoachCallback()">Call me back.</a></label>
                                </div>
                                <div class="box">
                                    <div *ngIf="callbackErrorMsg!=''" class="alert alert-danger" role="alert">
                                      {{callbackErrorMsg}}
                                    </div>
                                    <div *ngIf="callbackSuccessMsg!=''" class="alert alert-success" role="alert">
                                      {{callbackSuccessMsg}}
                                    </div>                                    
                                  </div>
                                <div *ngIf="displaySection=='UpdatePasswordSection'">

                                    <div class="form-group fullwidth">
                                        <div class="form-field">
                                            <input type="text" class="form-control" formControlName="Otp" numeric-field maxlength="6" 
                                               id="otpAutoFill" autocomplete="one-time-code" inputmode="numeric" Autofocus>
                                            <label for="otp" id="otpAutoFillLabel">Please Enter OTP</label>
                                            <div *ngIf="otpFormControls.Otp.touched && otpFormControls.Otp.errors"
                                                class="invalid-feedback">
                                                <div *ngIf="otpFormControls.Otp.errors.required">OTP is required</div>
                                                <div *ngIf="otpFormControls.Otp.errors.minlength">OTP must be 6 digits</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group required">
                                        <div class="form-field">
                                            <input id="Password" [type]="changetype?'password':'text'" [ngbPopover]="popContent" class="form-control" placeholder=""
                                                formControlName="Password" [(ngModel)]="password">
                                                <span class="eyeicon" (click)="viewpass()"><i><img ngOptimizedImage  [src]="visible?'assets/images/eye.png':'assets/images/eyeslash.png'"></i> </span>
                                            <label for="Password">Password</label>
                                            <app-password-strength-bar *ngIf="password" [passwordToCheck]="password"
                                                [barLabel]="'Password strength:'" class="psb"></app-password-strength-bar>
                                            <div *ngIf="otpFormControls.Password.touched && otpFormControls.Password.errors"
                                                class="invalid-feedback">
                                                <div *ngIf="otpFormControls.Password.errors.required">Password is required</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group  required">
                                        <div class="form-field">
                                            <input id="ConfirmPassword" [type]="changetypec?'password':'text'" class="form-control" placeholder=""
                                                formControlName="ConfirmPassword">
                                                <span class="eyeicon" (click)="viewpassofConfirm()"><i><img ngOptimizedImage  [src]="visiblec?'assets/images/eye.png':'assets/images/eyeslash.png'"></i> </span>
                                            <label for="ConfirmPassword">Confirm Password</label>
                                            <div *ngIf="otpFormControls.ConfirmPassword.touched && otpFormControls.ConfirmPassword.errors"
                                                class="invalid-feedback">
                                                <div *ngIf="otpFormControls.ConfirmPassword.errors.required">Confirm password is
                                                    required</div>
                                                <div *ngIf="otpFormControls.ConfirmPassword.errors.mustMatch">Password must match</div>
                                            </div>
                                        </div>
                                    </div>
                                    <p class="text-start px-md-0 mb-4" *ngIf="hasForgotPasswordError">
                                        {{forgotPasswordOtpWrongMsg}}
                                        <a href="javascript:void(0)" id="BackToSendOTPRequest" class="btnblue py-0" (click)="showSendOTPSection()">click
                                            here</a>
                                    </p>

                                </div>

        
                            </div>
                        </div>
                        <div class="d-flex">

                            <div *ngIf="!IsSuccess" class="d-flex w-100 flex-wrap justify-content-between">

                                <div class="col-md-12 text-end btnmbadj col-12">
                                <button *ngIf="sendOtpText=='Resend OTP'" name="btnSubmitForgotPassword" type="submit" 
                                        class="btnregister mb-4"
                                        [disabled]="otpForm.disabled" id="SubmitForgotPassword">Submit</button>
                                        

                                <button [name]="'btn'+sendOtpText+'ForgotPassword'" type="button" class="mt-md-0 mt-0"
                                        *ngIf="sendOtpText!='Resend OTP'"
                                        [id]="(sendOtpText=='Resend OTP')?'Resend OTPForForgotPassword':'Send OTPForForgotPassword'"
                                        (click)="sendOtp()"  
                                        [ngClass]="(sendOtpText=='Resend OTP')?'btnresendOtp':'btnregister mb-4'"
                                        [disabled]="disableOTPSendButton == true">{{requestOTPBtnDisplay}}</button>
 
                                <button [name]="'btn'+sendOtpText+'ForgotPassword'" type="button" class="mt-md-0 mt-0"
                                        *ngIf="sendOtpText =='Resend OTP' && hideResendOTPButton == false"
                                        [id]="(sendOtpText=='Resend OTP')?'Resend OTPForForgotPassword':'Send OTPForForgotPassword'"
                                        (click)="sendOtp()"  
                                        [ngClass]="(sendOtpText=='Resend OTP')?'btnresendOtp':'btnregister mb-4'"
                                        [ngStyle]="disableOTPSendButton == true ? {'border-color': '#767272','color': '#767272', 'opacity': '0.7'} : {'border-color': '#0075c9','color': '#0075c9'}"
                                        [disabled]="disableOTPSendButton == true">Resend OTP  <span *ngIf="secondsLeft > 0">in {{secondsLeft}}s</span></button>
                                     

                                </div>
                            </div>
                            <ng-template #popContent>
                                Be at least 8 characters <br>
                                Uppercase and lowercase letter (A,z) <br> 
                                Numeric character (0-9) <br>
                                Special character (!,%,&#64;,#,etc.)
                        </ng-template>
                        </div>
                    </form>
                    <!--mobile Image-->
                    <figure class="m-0 d-block d-md-none">
                        <div class="bgmg position-relative">
                            <img ngOptimizedImage  src="../../assets/images/registerimg.jpg" class="ps-md-5" alt="" />
                        </div>
                    </figure>
                </div>
                <div class="col-lg-6 col-md-5 d-flex flex-wrap pt-lg-3 ps-lg-5 ps-3 pe-lg-3 pe-3 boxblue align-items-stretch col-12">
                    <section class="d-flex align-items-stretch w-100 flex-wrap ps-lg-5">
                        <figure class="m-0 p- ps-md-5 d-md-block d-none w-100">
                            <div class="bgmg position-relative">
                                <img ngOptimizedImage  src="../../assets/images/registerimg.jpg" class="ps-lg-5" alt="" />
                            </div>
                        </figure>
                            <div class="helpline position-relative d-flex flex-wrap w-100 step-three-height">
                                <div class="col-md-12 px-3 col-12 center-align">
                                    <h2 class="mb-3 loginpage-caption bottomline">Need <b class="font-bolder"> help?</b></h2>
                                    <a class="phhelp" href="tel:+27860726526">+27 86 006 1058</a>
                                    <p class="mt-3 horset">Monday – Thursday 07:00-17:00</p>
                                    <p class="mt-3 horset">Friday 07:00-16:00</p>
                                </div>
                            </div>

                    </section>
                </div>
            </div>

        </div>
    </div>
</section>

<app-footer></app-footer>

